import React, { useState, useEffect } from 'react';
import ProfilePage from './ProfilePage';
import { fetchUserProfile, updatePhoneNumber } from '../../services/user/api';

const ProfileContainer = () => {
  const [profileData, setProfileData] = useState({
    username: '',
    personalemail: '',
    phonenumber: '',
    companyname: '',
  });

  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Modals
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      const startTime = performance.now();
      try {
        const response = await fetchUserProfile();
        const data = response.data;

        setProfileData({
          username: data.username || '',
          personalemail: data.personalemail || '',
          phonenumber: data.phonenumber || '',
          companyname: data.companyname || '',
        });

        const endTime = performance.now();
        //console.log(`✅ Profile loaded in ${(endTime - startTime).toFixed(2)} ms`);
      } catch (err) {
        console.error('❌ Error fetching profile:', err);
        setError('Failed to load profile');
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditClick = () => setIsEditingProfile(true);
  const handleCancelEdit = () => setIsEditingProfile(false);

  const handleSaveProfile = async () => {
    try {
      const { phonenumber, personalemail } = profileData;
      const response = await updatePhoneNumber(phonenumber, personalemail);

      if (response.data.status) {
        setShowSuccessModal(true);
        setIsEditingProfile(false);
      } else {
        setShowFailModal(true);
      }
    } catch (error) {
      console.error('❌ Error updating phone number:', error);
      setShowFailModal(true);
    }
  };

  if (loading) return <div className="loading">Loading profile...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <ProfilePage
        profileData={profileData}
        isEditingProfile={isEditingProfile}
        handleProfileChange={handleProfileChange}
        handleEditClick={handleEditClick}
        handleCancelEdit={handleCancelEdit}
        handleSaveProfile={handleSaveProfile}
      />

      {/* ✅ Success Modal */}
      {showSuccessModal && (
        <div className="profile-success-modal-overlay">
          <div className="profile-success-modal">
            <div className="profile-success-header">
              <h3>Profile Updated</h3>
              <button className="profile-success-close" onClick={() => setShowSuccessModal(false)}>×</button>
            </div>
            <div className="profile-success-body">
              <p>Your phone number has been updated successfully.</p>
            </div>
            <div className="profile-success-buttons">
              <button className="profile-success-ok-btn" onClick={() => setShowSuccessModal(false)}>OK</button>
            </div>
          </div>
        </div>
      )}

      {/* ❌ Fail Modal */}
      {showFailModal && (
        <div className="profile-fail-modal-overlay">
          <div className="profile-fail-modal">
            <div className="profile-fail-header">
              <h3>Update Failed</h3>
              <button className="profile-fail-close" onClick={() => setShowFailModal(false)}>×</button>
            </div>
            <div className="profile-fail-body">
              <p>Something went wrong while updating your phone number.</p>
            </div>
            <div className="profile-fail-buttons">
              <button className="profile-fail-ok-btn" onClick={() => setShowFailModal(false)}>OK</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileContainer;
